import { Flex, theme } from 'antd';
import { CardContent, CardShellEcho } from './common';
import EarningsChartEcho from '../charts/EarningsChartEcho';
import { EarningsApiResponse } from '@/types';
import NoDataMessageEcho from '../states/NoDataMessageEcho';
import { useEarningsQuery } from '@/services/revenueApi';
import useFetchQuery from '@/hooks/useFetchQuery';

const EstimatedEarningsCardEcho = ({ className }: { className?: string }) => {
  const { queryResult: earnings } = useFetchQuery(useEarningsQuery);

  return (
    <CardShellEcho className={className} testId="estimated-earnings-card" title="Estimated earnings">
      <CardContent
        {...earnings}
        renderData={(earningsData: EarningsApiResponse) => <Data data={earningsData} />}
      />
    </CardShellEcho>
  );
};

// const HeaderOptions = (
//   <div className="w-32">
//     {/* TODO: Filter table data on change */}
//     <Select value={'daily'}>
//       <SelectOption value="daily">Daily</SelectOption>
//       <SelectOption value="weekly" disabled>
//         Weekly
//       </SelectOption>
//       <SelectOption value="monthly" disabled>
//         Monthly
//       </SelectOption>
//     </Select>
//   </div>
// );

const Data = ({ data }: { data: EarningsApiResponse }) => {
  const { token } = theme.useToken();

  if (!data?.network_estimated_earnings_by_day?.length) {
    return <NoDataMessageEcho dataType="earnings" />;
  }

  return (
    <Flex vertical style={{ marginTop: token.marginLG }}>
      <EarningsChartEcho data={data.network_estimated_earnings_by_day} />
    </Flex>
  );
};

export default EstimatedEarningsCardEcho;
